import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { frames } from "../../../../Styles";
import { PageHeader, ReportModal, ReportCard, CardsView } from "../../../../Components";
import { ReportTemplate } from "../../../../Definitions";
import { Pages } from "../../../../Navigation/root";
import { useAppSelector } from "../../../../Store";
import { Graph_QL, useReportTemplate } from "../../../../Services";
import { ReportModalTypes } from "../../../../Components/Reports/_Reports/reportModalContext";
import { cloneDeep } from "lodash";

export default function Reports() {
  const { t } = useTranslation()
  const [modalType, setModalType] = useState<ReportModalTypes | null>(null);
  const [selectedTemplate, setSelectedTemplate] = useState<ReportTemplate | undefined>(undefined)

  const touch = 'ontouchstart' in window

  // #region | GraphQl
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);
  
  const {call: getTemplates, data: templateState} = useReportTemplate(connection);

  useEffect(() => {
    getTemplates({fetchAmount: 50, offset: 0});
  },[getTemplates])
  
  const templates = useMemo(() => {
    if (templateState && templateState[domain]) {
      return templateState[domain].data
    }
    return [];
  }, [domain, templateState])
  // #endregion

  return (
    <frames.Page_inner>
      <PageHeader
        zIndex={99}
        topHeader={t(`menuHeaders.${Pages.reports}`, { defaultValue: "reports" })}
        subHeader={t("menuHeaders.overview", { defaultValue: "overview" })}
        optionButtons={{
          contents: [t("reportPages.manageTemplates.templateOptions", {defaultValue: "template options"})],
          onClick: (i) => { if (i === 0 ) {setModalType(ReportModalTypes.createTemplate)}}
        }}
      />
      <frames._page_inner_content $hasScroll={touch}>
        <frames._page_inner_content_scroll>
          <CardsView
            items={templates.map((item, index) => (
              <ReportCard
                key={index}
                template={item}
                onCardSelect={(id) => {
                  setSelectedTemplate(cloneDeep(templates.find(template => template.templateId === id)));
                  setModalType(ReportModalTypes.createReport)
                }}
              />
            ))}
            cardBtn={{
              content: t("reportPages.reports.createReport", { defaultValue: "Create Report" }),
              subContent: t("reportPages.reports.createNewReport", { defaultValue: "Start a new report from scratch" }),
              onCardBtnClick: () => setModalType(ReportModalTypes.createReport)
            }}
          />
        </frames._page_inner_content_scroll>
      </frames._page_inner_content>

      {(modalType !== null) &&
        <ReportModal 
          isModalOpen={modalType !== null}
          closeModal={() => { setModalType(null); setSelectedTemplate(undefined)}}
          template={selectedTemplate}
          modalType={modalType}
        />
      }

    </frames.Page_inner>
  )
}